function TestDriveController($scope, $timeout, dataService) {
    var resetModel = function() {
        $scope.model = {
            firstName: null,
            lastName: null,
            company: null,
            title: null,
            email: null,
            email2: null,
            whereHearAbout: null,
            whereHearAboutSource: null
        };
    }
    resetModel();

    var resetVal = function () {
        $scope.saving = {
            active: false,
            success: false,
            denied: false,
            error: false
        };
        $scope.val = {
            firstName: {req: false},
            lastName: {req: false},
            companyName: {req: false},
            title: {req: false},
            email: {req: false, badFormat: false},
            email2: {match: false},
            hear: {req:false},
            captcha: {req:false}
        };
    };
    resetVal();

    var scrollToError = function () {
        $timeout(function () {
            var $elm = angular.element('.ui-has-error');
            if (!$elm || $elm.length <= 0) return;
            var o = $elm.offset();
            angular.element('html,body').animate({scrollTop: o.top - 90}, 'fast');
        }, 0);
    };

    $scope.submit = function (e) {
        e.preventDefault();
        resetVal();
        var isValid = true;

        console.log($scope.model);

        if (!$scope.model.email) {
            $scope.val.email.req = true;
            isValid = false;
        }
        else {
            if (!dataService.validEmail($scope.model.email)) {
                $scope.val.email.badFormat = true;
                isValid = false;
            }

            if (!$scope.model.email2 || $scope.model.email2.toLowerCase() !== $scope.model.email.toLowerCase()) {
                $scope.val.email2.match = true;
                isValid = false;
            }
        }


        if (!$scope.model.firstName) {
            $scope.val.firstName.req = true;
            isValid = false;
        }

        if (!$scope.model.lastName) {
            $scope.val.lastName.req = true;
            isValid = false;
        }

        if (!$scope.model.companyName) {
            $scope.val.companyName.req = true;
            isValid = false;
        }

        if (!$scope.model.title) {
            $scope.val.title.req = true;
            isValid = false;
        }
        if (!$scope.model.whereHearAbout) {
            $scope.val.hear.req = true;
            isValid = false;
        }

        $scope.model.captcha = grecaptcha.getResponse();
        if (!$scope.model.captcha) {
            $scope.val.captcha.req = true;
            isValid = false;
        }

        if (!isValid) {
            scrollToError();
            return;
        }

        $scope.saving.active = true;
        dataService.freeTestDrive($scope.model)
            .then(function (x) {
                var status = x.data;
                if (status === 'denied') {
                    $scope.saving.denied = true;
                    $scope.saving.active = false;
                    return;
                }
                resetModel();
                grecaptcha.reset();
                $scope.saving.success = true;
                $scope.saving.active = false;
            })
            .catch(function () {
                $scope.saving.error = true;
                $scope.saving.active = false;
            });
    };
}

angular.module('app')
    .component('testDriveForm', {
        transclude: true,
        controller: ['$scope', '$timeout', 'dataService', TestDriveController],
        templateUrl: '/assets/built/app/components/testDrive/testDriveForm.html'
    })
